import { IBaseModel } from "./abstract/ibaseModel.interface";

export class BaseModel implements IBaseModel {
    id: number;

     constructor(id: number) {
        this.id = id;
     }
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/base.model.ts